import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { prepararSessao } from "./lib/sessao-unica";

/*
  A sessão é lida antes do primeiro render.

  Com login único ela mora num cookie de domínio, e lê-la é assíncrono —
  o SDK do Supabase pode precisar renovar o token antes de devolvê-lo.
  Renderizar primeiro faria os guardas de rota olharem um `localStorage` ainda
  vazio e mandarem para o login quem já estava logado: a tela de login piscando
  em quem não pediu por ela.

  Sem login único isto resolve na hora e nada muda.
*/
prepararSessao().finally(() => {
  createRoot(document.getElementById("root")!).render(<App />);
});
